export const OAUTH_SETTINGS_PATH = "/settings-menu/oauth-settings";
